// src/data/gyms/NECheer.js
export const NECheer = {
  id: "necheer",
  name: "New England Cheer & Tumble",
  color: "#15803D", // Cheer Green
  lightColor: "#DCFCE7",
  logo: "🍀",

  teams: [
    { id: "seniorrubies", name: "Senior Rubies", level: "L2 Senior - D2" },
    {
      id: "youthblackpearls",
      name: "Youth Black Pearls",
      level: "L1 Youth - Flex - D2",
    },
    {
      id: "junioremeralds",
      name: "Junior Emeralds",
      level: "L2 Junior - Flex - D2",
    },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "12:03 PM",
      teamId: "seniorrubies",
      meet: "11:27 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "3:19 PM",
      teamId: "youthblackpearls",
      meet: "2:43 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "4:22 PM",
      teamId: "junioremeralds",
      meet: "3:46 PM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    {
      day: "Sunday",
      time: "9:59 AM",
      teamId: "seniorrubies",
      meet: "9:23 AM",
      panel: "Hall B",
    },
    // Found on PDF Row 198
    {
      day: "Sunday",
      time: "12:46 PM",
      teamId: "youthblackpearls",
      meet: "12:10 PM",
      panel: "Hall B",
    },
    // Found on PDF Row 218
    {
      day: "Sunday",
      time: "2:49 PM",
      teamId: "junioremeralds",
      meet: "2:13 PM",
      panel: "Hall B",
    },
  ],
};
